// import { modalOpenScrollFix, modalCloseScrollRestore } from '@/compositions/useModalScrollControl';
import store from '..';

export default {
	namespaced: true,
	state: {
		addressModal: false, // 주소 모달
		transferWorkModal: false,
		assignupModal: false, // 오더 배정 모달
		FMTransferModal: false, // FM 이관 모달
		installConfigurationAddModal: false, // 설치 구성 추가 모달
		TransferModal: false, // 재고 이관 모달
		LossModal: false, // 재고 불용/분실 모달
		SearchMaterialModal: false, // 부자재 조회 모달
		SearchEngineerModal: false, // 엔지니어 조회 모달
		TransferHistoryDetailModal: false, // 이관내역 상세 모달
		InventoryStatusDetailModal: false, // 재고현황 상세 모달
		SafetyCheckChecklistModal: false, // 안전점검 체크리스트 모달
		WorkStartRiskAssessmentModal: false, // 작업시작 위험성평가 모달
		materialListForModal: [], // 부자재 조회 모달에 전달할 리스트
	},
	mutations: {
		openModal(state, modalName) {
			state[modalName] = true;
			// modalOpenScrollFix();
		},
		closeModal(state, modalName) {
			state[modalName] = false;
			// modalCloseScrollRestore();
		},
		closeModalAll(state) {
			for (const modalName in state) {
				store.commit('modal/closeModal', modalName);
			}
		},
		setMaterialListForModal(state, list) {
			state.materialListForModal = list || [];
		},
	},
	actions: {},
	getters: {},
};
